import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Visibility as ViewIcon,
  Send as SendIcon,
  Download as DownloadIcon,
  PaymentOutlined as AddPaymentIcon,
  Cancel as CancelIcon,
  CheckCircleOutline as MarkPaidIcon
} from '@mui/icons-material';

const InvoiceActions = ({ 
  invoice, 
  onView, 
  onMail, 
  onDownload, 
  onAddPayment, 
  onCancel, 
  onMarkPaid 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action, event) => {
    event?.stopPropagation();
    action();
    handleClose();
  };

  // Determine if actions should be disabled
  const isMailDisabled = invoice?.status !== 'UP';
  const isAddPaymentDisabled = !invoice?.shared_on || invoice?.status === 'CN' || invoice?.status === 'RP' || invoice?.status === 'PD';
  const isCancelDisabled = invoice?.status === 'CN' || invoice?.status === 'RP';
  const isMarkPaidDisabled = invoice?.status === 'PD' || invoice?.status === 'CN' || invoice?.status === 'RP';

  return (
    <>
      <Tooltip title="Actions">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{ color: 'text.secondary' }}
          data-actions-button
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={(e) => handleAction(onView, e)}>
          <ListItemIcon>
            <ViewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={(e) => handleAction(onMail, e)}
          disabled={isMailDisabled}
        >
          <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mail Invoice</ListItemText>
        </MenuItem>

        <MenuItem onClick={(e) => handleAction(onDownload, e)}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Download</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={(e) => handleAction(onAddPayment, e)}
          disabled={isAddPaymentDisabled}
        >
          <ListItemIcon>
            <AddPaymentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add Payment</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={(e) => handleAction(onCancel, e)}
          disabled={isCancelDisabled}
        >
          <ListItemIcon>
            <CancelIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cancel</ListItemText>
        </MenuItem>

        <MenuItem 
          onClick={(e) => handleAction(onMarkPaid, e)}
          disabled={isMarkPaidDisabled}
        >
          <ListItemIcon>
            <MarkPaidIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mark as Paid</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default InvoiceActions;
